import { createFileRoute } from "@tanstack/react-router";
import { Header } from "@/components/petmoon/Header";
import { Hero } from "@/components/petmoon/Hero";
import { Features } from "@/components/petmoon/Features";
import { BookingWizard } from "@/components/petmoon/BookingWizard";
import { LunaTribute } from "@/components/petmoon/LunaTribute";
import { Footer } from "@/components/petmoon/Footer";
import logoAsset from "@/assets/petmoon-logo.png.asset.json";
import heroPets from "@/assets/hero-pets.webp";


const SITE_URL = "https://petmoon.mgwebserver.com";
const OG_IMAGE = `${SITE_URL}${logoAsset.url}`;

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      { title: "PetMoon | Transporte Seguro y Amoroso para Mascotas" },
      {
        name: "description",
        content:
          "Servicio de transporte privado y seguro para perros y gatos. Unidades sanitizadas, arnés de protección y monitoreo en vivo para tus mascotas.",
      },
      {
        name: "keywords",
        content:
          "transporte de mascotas, taxi para perros, traslado veterinario, uber para mascotas, pet taxi, transporte canino",
      },
      {
        property: "og:title",
        content: "PetMoon | Transporte Seguro y Amoroso para Mascotas",
      },
      {
        property: "og:description",
        content:
          "Traslada a tu perro o gato con total tranquilidad. Cotiza y agenda tu viaje en línea.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: `${SITE_URL}/` },
      { property: "og:image", content: OG_IMAGE },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:image", content: OG_IMAGE },
    ],
    links: [
      { rel: "canonical", href: `${SITE_URL}/` },
      { rel: "preload", as: "image", href: heroPets, fetchpriority: "high" },
    ],

    scripts: [
      {
        type: "application/ld+json",
        children: JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          name: "PetMoon",
          url: SITE_URL,
          image: OG_IMAGE,
          description: "Transporte seguro y amoroso para mascotas.",
          slogan: "El viaje que tu mascota merece, inspirado en el amor por Luna.",
          email: "moonpet90@gmail.com",
          telephone: "+523313450460",
          priceRange: "$$",
          serviceType: "Transporte de mascotas y taxi pet-friendly",
          currenciesAccepted: "MXN",
          address: {
            "@type": "PostalAddress",
            addressLocality: "Zapopan",
            addressRegion: "Jalisco",
            addressCountry: "MX",
          },
          geo: {
            "@type": "GeoCoordinates",
            latitude: 20.6597,
            longitude: -103.3496,
          },
          areaServed: [
            { "@type": "City", name: "Guadalajara", address: { "@type": "PostalAddress", addressRegion: "Jalisco", addressCountry: "MX" } },
            { "@type": "City", name: "Zapopan", address: { "@type": "PostalAddress", addressRegion: "Jalisco", addressCountry: "MX" } },
            { "@type": "City", name: "Tlaquepaque", address: { "@type": "PostalAddress", addressRegion: "Jalisco", addressCountry: "MX" } },
            { "@type": "City", name: "Tonalá", address: { "@type": "PostalAddress", addressRegion: "Jalisco", addressCountry: "MX" } },
            { "@type": "City", name: "Tlajomulco de Zúñiga", address: { "@type": "PostalAddress", addressRegion: "Jalisco", addressCountry: "MX" } },
            { "@type": "State", name: "Jalisco", address: { "@type": "PostalAddress", addressRegion: "Jalisco", addressCountry: "MX" } },
          ],
          serviceArea: {
            "@type": "GeoCircle",
            geoMidpoint: { "@type": "GeoCoordinates", latitude: 20.6597, longitude: -103.3496 },
            geoRadius: 30000,
          },

        }),
      },
    ],
  }),
  component: LandingPage,
});


function LandingPage() {
  return (
    <div className="min-h-screen bg-background font-sans text-foreground antialiased">
      <Header />
      <main>
        <Hero />
        <Features />
        <BookingWizard />
        <LunaTribute />
      </main>
      <Footer />
    </div>
  );
}
